<survey-snack-bar [form]="form" #surveySnackBar (submit)="onSubmit()">
	<h3 title translate="ai-trial-survey-title" class="ai-trial-survey-title"></h3>
	<p description id="feedback-description" class="message" translate="ai-trial-survey-description"></p>

	<ng-container #projectedContent>
		<button
			class="tertiary-btn dismiss-btn"
			(click)="onClose()"
			translate="common_dismiss">
		</button>
	</ng-container>
</survey-snack-bar>
